import * as ActionTypes from '../constants/ActionTypes';

const INITIAL_STATE = {
	loading: true,
	id: '',
	email: '',
	userName: '',
	name: '',
	address: null,
	gender: null,
	phone: [],
	photos: [],
	achievement: [],
	profilePicture: { url: '', hash: '' },
	level: null,
	videoRef: null,
	links: [],
	bio: null,
	occupation: null,
	socialLinks: [],
};

const getUserData = (
	state,
	{
		email,
		userId,
		userName,
		address,
		gender,
		name,
		links,
		photos,
		phone,
		achievement,
		profilePicture,
		level,
		videoRef,
		bio,
		occupation,
		socialLinks,
	}
) => ({
	...state,
	loading: false,
	email,
	userName,
	achievement,
	id: userId,
	address,
	photos,
	links,
	gender,
	name: name ? name : userName,
	phone,
	profilePicture,
	level,
	videoRef,
	bio,
	occupation,
	socialLinks,
});

const updateProfileData = (state, payload) => ({
	...state,
	...payload,
});

const addSocialMediaProfileData = (state, payload) => {
	const data = state?.socialLinks;
	return {
		...state,
		socialLinks: [...data, payload.socialMedia],
	};
};

const removeSocialMediaProfileData = (state, payload) => {
	const data = state?.socialLinks;
	const index = data.findIndex(key => key._id === payload);
	data.splice(index, 1);
	return {
		...state,
		socialLinks: [...data],
	};
};

const removeLinkData = (state, payload) => {
	const data = state?.links;
	const index = data.findIndex(key => key._id === payload);
	data.splice(index, 1);
	return {
		...state,
		links: [...data],
	};
};

const removeAchieveData = (state, payload) => {
	const data = state?.achievement;
	const index = data.findIndex(key => key._id === payload);
	data.splice(index, 1);
	return {
		...state,
		achievement: [...data],
	};
};

const removePhotoeData = (state, payload) => {
	const data = state?.photos;
	const index = data.findIndex(key => key._id === payload?.id);
	data.splice(index, 1);
	return {
		...state,
		photos: [...data],
	};
};

const addAchievementsProfileData = (state, payload) => {
	const data = state?.achievement;
	return {
		...state,
		achievement: [...data, payload.achievement],
	};
};

const addPhotosProfileData = (state, payload) => {
	const data = state?.photos;
	return {
		...state,
		photos: [...data, payload.photo],
	};
};

const addLinksData = (state, payload) => {
	const data = state?.links;
	return {
		...state,
		links: [...data, payload.links],
	};
};

export default (state = INITIAL_STATE, { type, payload }) => {
	switch (type) {
		case ActionTypes.GET_USER_INFO_SUCCESS:
			return getUserData(state, payload);
		case ActionTypes.UPDATE_PROFILE_SUCCESS:
			return updateProfileData(state, payload);
		case ActionTypes.ADD_SOCIAL_MEDIA_SUCCESS:
			return addSocialMediaProfileData(state, payload);
		case ActionTypes.ADD_ACHIEVEMENTS_SUCCESS:
			return addAchievementsProfileData(state, payload);
		case ActionTypes.ADD_PHOTOS_SUCCESS:
			return addPhotosProfileData(state, payload);
		case ActionTypes.ADD_LINKS_SUCCESS:
			return addLinksData(state, payload);
		case ActionTypes.REMOVE_SOCIAL_MEDIA_SUCCESS:
			return removeSocialMediaProfileData(state, payload);
		case ActionTypes.REMOVE_LINK_SUCCESS:
			return removeLinkData(state, payload);
		case ActionTypes.REMOVE_ACHIEVEMENT_SUCCESS:
			return removeAchieveData(state, payload);
		case ActionTypes.REMOVE_PHOTO_SUCCESS:
			return removePhotoeData(state, payload);
		default:
			return state;
	}
};
